import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostB2BBeneficiaryAuthorization,
	PostB2BBeneficiaryAuthorizationModel,
	PostB2BBeneficiaryAuthorizationParams,
} from 'domain/usecases/private/profile/post-b2b-beneficiary-authorization';

export class RemotePostB2BBeneficiaryAuthorization implements PostB2BBeneficiaryAuthorization {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostB2BBeneficiaryAuthorizationModel>,
	) {}

	async post(
		params: PostB2BBeneficiaryAuthorizationParams,
	): Promise<PostB2BBeneficiaryAuthorizationModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
